import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { ContentProvider } from "./context/ContentContext";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/*" element={<Admin />} />
          </Routes>
        </ContentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
